"use strict"
const Transform = require('stream').Transform
const inherits = require('util').inherits

function MapStream (mapFunc) {
  if (!(this instanceof MapStream)) { return new MapStream(mapFunc) }

  if (typeof mapFunc !== 'function') {
    throw Error("MapStream mapFunc must be a function")
  }
  this.mapFunc = mapFunc
  Transform.call(this, {objectMode: true, highWaterMark: 0})
}

inherits(MapStream, Transform)

MapStream.prototype._transform = function (data, enc, next) {
  next(null, this.mapFunc.call(null, data))
}

module.exports = MapStream
